import { render, staticRenderFns } from "./appealApproval.vue?vue&type=template&id=32980124&scoped=true&"
import script from "./appealApproval.vue?vue&type=script&lang=js&"
export * from "./appealApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32980124",
  null
  
)

export default component.exports